import { render, staticRenderFns } from "./search_product.vue?vue&type=template&id=07b9a3a4&scoped=true&"
import script from "./search_product.vue?vue&type=script&lang=ts&"
export * from "./search_product.vue?vue&type=script&lang=ts&"
import style0 from "./search_product.vue?vue&type=style&index=0&id=07b9a3a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b9a3a4",
  null
  
)

export default component.exports